module.exports = __webpack_public_path__ + "img/sensor.768ef41d.png";